import { useDispatch, useSelector } from "react-redux";

import * as constants from "@/constants";
import { RootState } from "@/reducers/types";
import { useMachineApi } from "@/sx-layout/components/plotmap/hooks/useMachineApi";
import { PlotMapState } from "@/sx-layout/components/plotmap/reducers/plotmap";

/**
 * machine関連のstateと更新処理を集約する
 * redux stateをここに隠蔽することで後からzustandなどに移行しやすくする
 */
export const usePlotMapMachine = () => {
  const dispatch = useDispatch();
  const plotPlanId = useSelector((state: RootState) => state.plotmap.plotPlanId);
  const machineApi = useMachineApi(Number(plotPlanId));

  const { machines } = useSelector<RootState, PlotMapState>((state) => state.plotmap);

  const refreshMachines = async (): Promise<void> => {
    const response = await machineApi.fetchMachines();
    dispatch({
      type: constants.PLOT_MAP_END_FETCH_MACHINES,
      payload: response.machines,
    });
  };

  return {
    machines,
    refreshMachines,
  } as const;
};
